import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en.json";
import translationES from "./locales/es.json";

/**
 * Available language resources for the application
 * 
 * Translation structure:
 * - header: Shared navigation content across all versions
 * - footer: Shared footer content across all versions
 * - common: Shared common elements (logos, alt texts, etc.)
 * - versionA: Content specific to Version A for A/B testing
 * - versionB: Content specific to Version B for A/B testing (add as needed)
 * - versionC: Content specific to Version C for A/B testing (add as needed)
 */
const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

/**
 * Initializes i18next with language detection and React integration
 * 
 * Configuration includes:
 * - Browser language detection
 * - Fallback to English if language not available
 * - React integration via react-i18next
 * - JSON interpolation support
 */
i18n
  .use(LanguageDetector) // Detects user language from browser
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en", // Default language
    supportedLngs: ["en", "es"], // Supported languages
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Language detection order
      order: ["localStorage", "navigator"],
      caches: ["localStorage"], // Store language preference
    },
  });

export default i18n;

